import React, { FC } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { CreateAndCloseLinkedApi, LinkedApi } from "../../../services/Api/Organization/types";
import CreateEntityModalForm from "./CreateEntityModalForm";

interface Props {
	isShown: boolean;
	onHide: () => void;
	onGoBack: () => void;
	name?: string;
	linkedId: number;
	onSuccess: (response: LinkedApi) => void;
}

const CreateContactModalForm: FC<Props> = ({ onGoBack, isShown, onHide, name, linkedId, onSuccess }) => {
	const form = useForm<CreateAndCloseLinkedApi>({
		criteriaMode: "all",
		defaultValues: {
			name,
		},
	});
	const { t } = useTranslation();
	const {
		formState: { errors },
		register,
	} = form;

	return (
		<CreateEntityModalForm
			title={t("modules.app_link.field.create_contact.title")}
			onHide={onHide}
			resourceType="CONTACT"
			isShown={isShown}
			onGoBack={onGoBack}
			linkedId={linkedId}
			onSuccess={onSuccess}
			form={form}
		>
			<FormInput name="name" errors={errors} register={register} label={t("lib:common.word.name")} />
		</CreateEntityModalForm>
	);
};

export default CreateContactModalForm;
